import React, { useState } from "react";
import ReactApexChart from "react-apexcharts";

const PatLineChart = ({
  providers,
  totalEncounters,
  signedEncounters,
  unsignedEncounters,
  nonduplicatePatcount,
  CPTCount,
  UnitCount,
  maxvalue
}) => {


  const adjustedMaxValue = Math.ceil(maxvalue / 50) * 50;
  const xTickAmount = adjustedMaxValue / 50;


  const chartData = {
    series: [
      { name: "Total Encounters", data: totalEncounters },
      { name: "Signed Encounters", data: signedEncounters },
      { name: "Unsigned Encounters", data: unsignedEncounters },
      { name: "Total Patients", data: nonduplicatePatcount },
      { name: "Total CPTs", data: CPTCount },
      { name: "Total Units", data: UnitCount },
    ],
    options: {
      chart: {
        height: 350,
        type: 'line',
        zoom: { enabled: false }
      },
      dataLabels: { enabled: false },
      stroke: { curve: 'smooth' },
      title: { text: '', align: 'left' },
      grid: {
        row: { colors: ['#f3f3f3', 'transparent'], opacity: 0.5 }
      },
      xaxis: {
        categories: providers
      },
      yaxis: {
        min: 0,
        max: adjustedMaxValue,
        tickAmount: xTickAmount,
        labels: {
          formatter: (val) => Math.round(val)
        },
      },
      legend: {
        position: "top",
        fontSize: "18px",
      },
    },
  };
  

  return (
    <div className="mt-5">
      <div id="chart" style={{ width: '1100px', marginLeft: '200px' }}>
        <ReactApexChart options={chartData.options} series={chartData.series} type="line" height={550} />
      </div>
    </div>
  );
};

export default PatLineChart;
